/* KL konfiguratory szynowe: wspolny silnik v2 (27.10.2026, KOPIA motywu 207394210140, czeka na akceptacje).
   Dane systemu: assets/kl-konfig-szyn-<system>.json (rola -> SKU per montaz/kolor + reguly ilosci), produkty: kolekcje ?view=konfig-szyn-dane.
   Reguly z danych: szyny (dlugosci), laczenie, naroznik (L/P), t, x, pion, zasilanie_koniec / zasilanie_srodek, koniec (zaslepka),
   zwis (zawiesia na szyne), mocowanie (sufit podwieszany), zasilacze (48V/24V: dobor po mocy opraw + zapas), max_w per montaz.
   Kroki: 1 uklad, 2 montaz i kolor, 3 wymiary (kalkulator), 4 oprawy, 5 podsumowanie. "Dalej" klika uzytkownik.
   Koszyk: jeden POST /cart/add.js z lista items (properties _zestaw = id konfiguracji); przy bledzie pozycje po kolei. CartAddEvent na koncu. */
import { CartAddEvent } from '@theme/events';

const root = document.querySelector('[data-kl-ks]');
if (root) start(root);

function start(root) {
  const $main = root.querySelector('[data-kl-ks-main]');
  const $bok = root.querySelector('[data-kl-ks-bok]');
  const $kroki = root.querySelector('[data-kl-ks-kroki]');
  const ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* boki: kolejne odcinki; skrety: kierunek narożnikow (P = w prawo przy rysunku od zasilania), konce: wolne konce */
  const UKLADY = {
    prosty: { n: 'Prosty', boki: ['A'], L: 0, T: 0, X: 0, pion: 0, konce: 2, zas: 'koniec', opis: 'Jedna linia, zasilanie na końcu' },
    srodek: { n: 'Prosty, zasilanie w środku', boki: ['A', 'B'], L: 0, T: 0, X: 0, pion: 0, konce: 2, zas: 'srodek', opis: 'Dwa ramiona od zasilania środkowego' },
    L: { n: 'Kształt L', boki: ['A', 'B'], L: 1, T: 0, X: 0, pion: 0, konce: 2, zas: 'koniec', opis: 'Narożnik 90°' },
    U: { n: 'Kształt U', boki: ['A', 'B', 'C'], L: 2, T: 0, X: 0, pion: 0, konce: 2, zas: 'koniec', opis: 'Dwa narożniki' },
    T: { n: 'Kształt T', boki: ['A', 'B', 'C'], L: 0, T: 1, X: 0, pion: 0, konce: 3, zas: 'koniec', opis: 'Trzy ramiona od łącznika T' },
    X: { n: 'Krzyż X', boki: ['A', 'B', 'C', 'D'], L: 0, T: 0, X: 1, pion: 0, konce: 4, zas: 'koniec', opis: 'Cztery ramiona od łącznika X' },
    prostokat: { n: 'Prostokąt (zamknięty)', boki: ['A', 'B'], x2: true, L: 4, T: 0, X: 0, pion: 0, konce: 0, zas: 'srodek', opis: 'Rama A x B, zasilanie w środku boku A' },
    sciana: { n: 'Sufit i ściana', boki: ['A', 'B'], L: 0, T: 0, X: 0, pion: 1, konce: 2, zas: 'koniec', opis: 'A na suficie, B schodzi na ścianę' }
  };
  const MONTAZE = {
    natynk: { n: 'Natynkowy', opis: 'Szyna przykręcona do sufitu' },
    zwis: { n: 'Zwieszany na linkach', opis: 'Szyna na zawiesiach pod sufitem' },
    wpusz: { n: 'Wpuszczany', opis: 'Szyna w suficie (zabudowa)' }
  };
  const KOLORY = { czarny: { n: 'Czarny', c: '#1c1c1c' }, bialy: { n: 'Biały', c: '#f4f4f2' }, zloty: { n: 'Złoty', c: '#c9a55a' } };
  const KROKI = ['Układ', 'Montaż i kolor', 'Wymiary', 'Oprawy', 'Podsumowanie'];

  let SYS = null, R = null, P = [], BYSKU = {}, LAMPY = [];
  const s = { krok: 0, uklad: null, montaz: null, sufit: null, kolor: null, dl: {}, flex: false, lustro: false, oslona: false, opr: {}, fk: 'wszystkie', fr: 'wszystkie', busy: false, msg: null };

  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  const zl = (gr) => (gr / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
  const num = (v) => { const x = parseFloat(String(v || '').replace(',', '.')); return isFinite(x) ? x : 0; };
  const fm = (x) => (Math.round(x * 100) / 100).toLocaleString('pl-PL');

  /* ---------- dane ---------- */
  async function pobierzKolekcje(url) {
    let out = [], page = 1, pages = 1;
    do {
      /* bez Accept: application/json (Shopify oddaje wtedy JSON kolekcji); ponowienia przy 429 / chwilowej odpowiedzi HTML */
      let j = null;
      for (let p = 0; p < 6 && !j; p++) {
        try { j = JSON.parse(await (await fetch(`${url}?view=konfig-szyn-dane&page=${page}`)).text()); } catch (_) { await new Promise((r) => setTimeout(r, 1000 * (p + 1))); }
      }
      if (!j) throw new Error('kolekcja');
      out = out.concat(j.p); pages = j.pages; page++;
    } while (page <= pages);
    return out;
  }
  /* produkty po SKU przez wyszukiwarke sklepu (templates/search.konfig-szyn-dane.liquid), paczki po 50 SKU */
  async function pobierzSku(lista) {
    const out = [];
    for (let i = 0; i < lista.length; i += 50) {
      const q = lista.slice(i, i + 50).map((x) => `variants.sku:${x}`).join(' OR ');
      const u = `${ROOT_URL}search?view=konfig-szyn-dane&type=product&q=${encodeURIComponent(q)}`; /* bez options[] i preview_theme_id: Shopify przekierowuje (302) i gubi view */
      let j = null;
      for (let p = 0; p < 6 && !j; p++) {
        try { j = JSON.parse(await (await fetch(u, { credentials: 'same-origin' })).text()); } catch (_) { await new Promise((r) => setTimeout(r, 1200 * (p + 1))); }
      }
      if (!j) throw new Error('search');
      out.push(...j.p);
    }
    return out;
  }
  /* pojedyncze produkty spoza kolekcji: /products/<handle>.js (po 6 rownolegle) */
  async function pobierzHandle(lista) {
    const out = [];
    const jeden = async (h) => {
      for (let p = 0; p < 4; p++) {
        try {
          const r = await fetch(`${ROOT_URL}products/${encodeURIComponent(h)}.js`);
          if (r.status === 404) return;
          if (!r.ok) throw new Error(r.status);
          const j = await r.json();
          j.variants.forEach((v) => {
            const im = (v.featured_image && v.featured_image.src) || j.featured_image;
            out.push({ v: v.id, s: v.sku, h: j.handle, t: j.title, vt: j.variants.length > 1 ? v.title : '', ty: j.type, vn: j.vendor, c: v.price, cc: v.compare_at_price || 0, a: v.available, i: im ? (im.startsWith('//') ? 'https:' + im : im) + (im.includes('?') ? '&' : '?') + 'width=360' : null });
          });
          return;
        } catch (_) { await new Promise((r) => setTimeout(r, 1000 * (p + 1))); }
      }
    };
    for (let i = 0; i < lista.length; i += 6) await Promise.all(lista.slice(i, i + 6).map(jeden));
    return out;
  }
  function wszystkieSkuElementow() {
    const set = new Set();
    Object.values(SYS.elementy).forEach((m) => Object.values(m).forEach((k) => Object.values(k).forEach((sku) => [].concat(sku).forEach((x) => set.add(String(x))))));
    (SYS.dodatki || []).forEach((d) => Object.values(d.sku).forEach((x) => set.add(String(x))));
    (SYS.wyklucz || []).forEach((x) => set.add(String(x)));
    return set;
  }
  function przygotuj() {
    P.forEach((p) => { if (p.s) BYSKU[String(p.s).trim()] = p; });
    const skuEl = wszystkieSkuElementow();
    const seen = new Set();
    const tylko = SYS.oprawy_sku ? new Set(SYS.oprawy_sku.map(String)) : null;
    LAMPY = P.filter((p) => {
      const k = String(p.s).trim();
      if (skuEl.has(k) || seen.has(p.v)) return false;
      if (tylko && !tylko.has(k)) return false;
      if (SYS.oprawy_typ && !new RegExp(SYS.oprawy_typ, 'i').test(p.ty || '')) return false;
      seen.add(p.v); return true;
    }).map((p) => {
      const t = p.t.replace(new RegExp('^' + (SYS.prefiks_tytulu || 'Nowodvorski\\s+System szynowy\\s+'), 'i'), '');
      let rodz = '';
      if (SYS.rodzina_regex) rodz = (t.match(new RegExp(SYS.rodzina_regex, 'i')) || [])[1] || '';
      if (!rodz) rodz = t.split(/\s+/).slice(0, 2).join(' ');
      const inf = SYS.oprawy_info && SYS.oprawy_info[String(p.s).trim()];
      if (inf && inf[0]) rodz = inf[0];
      const w = inf && inf[1] ? String(inf[1]) : (p.t.match(/(\d+(?:[.,]\d+)?)\s*W\b/) || [])[1];
      const kol = /czarn|black/i.test(p.t) ? 'czarny' : /biał|white/i.test(p.t) ? 'bialy' : 'inne';
      return Object.assign({}, p, { rodz: rodz.trim(), w: w ? num(w) : 0, kol, tk: t });
    }).sort((a, b) => a.rodz.localeCompare(b.rodz) || a.w - b.w || a.c - b.c);
  }

  /* ---------- elementy ---------- */
  function mapa() {
    const m = s.montaz === 'wpusz' && SYS.elementy.wpusz ? 'wpusz' : s.montaz === 'zwis' && SYS.elementy.zwis ? 'zwis' : 'natynk';
    return Object.assign({}, (SYS.elementy.natynk || {})[s.kolor] || {}, (SYS.elementy[m] || {})[s.kolor] || {});
  }
  function el(rola) { const sku = mapa()[rola]; if (!sku) return null; const k = String([].concat(sku)[0]); return { sku: k, p: BYSKU[k] }; }
  const lista = (x, kier) => (x == null ? [] : Array.isArray(x) ? x : x[kier] || x.P || []);

  function boki() { return UKLADY[s.uklad].boki.map((b) => ({ b, d: num(s.dl[b]) })); }
  function dlugoscCalk() { const u = UKLADY[s.uklad]; return boki().reduce((a, x) => a + x.d, 0) * (u.x2 ? 2 : 1); }
  function wymiaryOk() {
    if (!s.uklad) return false;
    if (boki().some((x) => x.d < (SYS.min_bok || 0.3) || x.d > SYS.max_m)) return false;
    return dlugoscCalk() <= SYS.max_m;
  }

  /* podzial boku na szyny: najdluzsze, ostatnia najkrotsza pokrywajaca reszte; dostepnosc: pomija niedostepne dlugosci, jesli sa inne */
  function podziel(d) {
    const szyny = (R.szyny || []).map((x) => Object.assign({}, x, { e: el(x.rola) })).filter((x) => x.e);
    let dost = szyny.filter((x) => x.e.p && x.e.p.a);
    if (!dost.length) dost = szyny;
    dost.sort((a, b) => b.m - a.m);
    const out = []; let rest = d;
    while (rest > 0.001) {
      const big = dost[0];
      if (rest > big.m + 0.001) { out.push(big); rest -= big.m; continue; }
      const fit = dost.filter((x) => x.m + 0.001 >= rest).sort((a, b) => a.m - b.m)[0];
      out.push(fit); rest -= fit.m;
    }
    return { szyny: out, zapas: -rest };
  }

  function oblicz() {
    const u = UKLADY[s.uklad];
    const q = {}; const add = (r, n) => { if (r && n > 0) q[r] = (q[r] || 0) + n; };
    const addL = (arr, n) => arr.forEach((r) => add(r, n));
    const kier = s.lustro ? 'L' : 'P';
    const ciecie = [], uwagi = [];
    const bb = u.x2 ? boki().concat(boki()) : boki();
    let metry = 0, odcinki = 0, polaczenia = 0, zawiesia = 0, mocow = 0, pierwszeA = 0;
    bb.forEach((x, i) => {
      const { szyny, zapas } = podziel(x.d);
      szyny.forEach((sz) => { add(sz.rola, 1); metry += sz.m; if (R.zwis && R.zwis.na_szyne) zawiesia += R.zwis.na_szyne[sz.rola] || 0; if (R.mocowanie && R.mocowanie.na_szyne) mocow += R.mocowanie.na_szyne[sz.rola] || 0; });
      odcinki += szyny.length; polaczenia += szyny.length - 1;
      if (i === 0) pierwszeA = szyny.length - 1;
      const cm = Math.round(zapas * 100);
      if (cm >= 5 && i < u.boki.length) ciecie.push(`bok ${x.b}: skróć ostatnią szynę o ${cm} cm`);
    });
    /* punkty mocowania przy odstepie max odstep_m: na kazdy prosty bok ceil(d/odstep)+1, wezly wspolne (narozniki, T, X, zasilanie srodkowe) liczone raz */
    const punkty = (odst) => bb.reduce((a, x) => a + Math.ceil(x.d / odst - 0.001) + 1, 0) - (u.L + 2 * u.T + 3 * u.X + u.pion + (u.zas === 'srodek' && s.uklad !== 'prostokat' ? 1 : 0));
    if (R.zwis && R.zwis.odstep_m) zawiesia = punkty(R.zwis.odstep_m);
    if (R.mocowanie && R.mocowanie.odstep_m) mocow = punkty(R.mocowanie.odstep_m);
    addL(lista(R.laczenie), polaczenia);
    addL(lista(s.flex && R.naroznik_flex ? R.naroznik_flex : R.naroznik, kier), u.L);
    addL(lista(R.t, kier), u.T); addL(lista(R.x), u.X); addL(lista(R.pion), u.pion);
    if (u.zas === 'srodek') {
      addL(lista(R.zasilanie_srodek, kier), 1);
      if (s.uklad === 'prostokat' && lista(R.zasilanie_srodek, kier).length) {
        if (pierwszeA > 0) lista(R.laczenie).forEach((r) => { q[r] -= 1; if (q[r] <= 0) delete q[r]; });
        else ciecie.push('bok A: przetnij szynę na dwa odcinki i połącz zasilaniem środkowym (instrukcja producenta pozwala ciąć szynę)');
      }
    } else addL(lista(R.zasilanie_koniec, kier), 1);
    addL(lista(R.koniec), Math.max(0, u.konce - (u.zas === 'koniec' && R.zasilanie_na_koncu !== false ? 1 : 0)));
    if (s.montaz === 'zwis' && R.zwis) {
      addL(lista(R.zwis.zasilajace), 1);
      const n = Math.max(0, zawiesia - (R.zwis.odjac || 0));
      add(R.zwis.zawiesie, Math.ceil(n / (R.zwis.w_paczce || 1)));
      if (R.zwis.uwaga) uwagi.push(R.zwis.uwaga);
    }
    if (s.montaz === 'wpusz' && (s.sufit === 'podwieszany' || (R.mocowanie && R.mocowanie.zawsze)) && R.mocowanie) { add(R.mocowanie.rola, (R.mocowanie.na_szyne || R.mocowanie.odstep_m) ? mocow : Math.ceil((R.mocowanie.na_metr || 0) * metry - 0.001)); if (R.mocowanie.uwaga) uwagi.push(R.mocowanie.uwaga); }
    const zas = dobierzZasilacze();
    if (zas) {
      zas.poz.forEach(([r, n]) => add(r, n));
      if (zas.n > 1 && R.podzial_obwodow) {
        const r = R.podzial_obwodow.usun; if (r && q[r]) { q[r] = Math.max(0, q[r] - (zas.n - 1)); }
        uwagi.push(R.podzial_obwodow.uwaga || `Instalacja ma ${zas.n} obwody: każdy zasilacz zasila osobny odcinek.`);
      }
    }
    if (s.oslona && R.oslona) Object.entries(R.oslona).forEach(([sz, os]) => add(os, q[sz] || 0));
    const mp = mapa();
    const poz = Object.entries(q).filter(([r, n]) => n > 0 && mp[r] != null).map(([rola, n]) => {
      const e = el(rola);
      return { rola, n, nazwa: (SYS.role && SYS.role[rola]) || rola, sku: e && e.sku, p: e && e.p };
    });
    return { poz, ciecie, metry, odcinki, uwagi, zas };
  }

  function mocOpraw() { return lampyWybrane().reduce((a, x) => a + x.n * x.l.w, 0); }
  function maxW() { const m = SYS.max_w; if (m == null) return null; if (typeof m === 'number') return m; return m[s.montaz] == null ? null : m[s.montaz]; }

  /* 48V/24V: najmniejszy zasilacz z zapasem; gdy brak - kilka najwiekszych (kazdy = osobny punkt zasilania) */
  function dobierzZasilacze() {
    if (!R.zasilacze || !R.zasilacze.length) return null;
    const w = mocOpraw(); const zap = 1 + (R.zapas_mocy == null ? 0.1 : R.zapas_mocy);
    const lst = R.zasilacze.slice().sort((a, b) => a.w - b.w);
    const need = Math.max(w * zap, 1);
    let wyb = lst.find((z) => z.w >= need), n = 1;
    if (!wyb) { wyb = lst[lst.length - 1]; n = Math.ceil(need / wyb.w); }
    const poz = [[wyb.rola, n]]; (wyb.dodatki || []).forEach((r) => poz.push([r, n]));
    return { poz, n, w: wyb.w, moc: w, need, opis: `${n} x ${wyb.w} W (opraw ${w} W + ${Math.round((zap - 1) * 100)}% zapasu)` };
  }

  function lampyWybrane() { return Object.entries(s.opr).filter(([, n]) => n > 0).map(([v, n]) => ({ l: LAMPY.find((x) => String(x.v) === v), n })).filter((x) => x.l); }
  function wszystkiePozycje() {
    const z = s.uklad && s.montaz && s.kolor && wymiaryOk() ? oblicz().poz.filter((x) => x.p) : [];
    return z.map((x) => ({ v: x.p.v, q: x.n, t: x.nazwa, p: x.p, r: x.rola.startsWith('szyna') ? 'szyna' : 'element' })).concat(lampyWybrane().map((x) => ({ v: x.l.v, q: x.n, t: x.l.tk, p: x.l, r: 'oprawa' })));
  }

  /* ---------- rysunek SVG ---------- */
  function svg(uk) {
    const ukl = uk || s.uklad; if (!ukl) return '';
    const u = UKLADY[ukl];
    const d = (b) => Math.max(num(s.dl[b]) || 1, 0.3);
    const W = 260, H = 170, pad = 28;
    const lines = [], labels = []; let zas = null;
    const L = (x1, y1, x2, y2, b) => { lines.push([x1, y1, x2, y2]); if (b) labels.push([(x1 + x2) / 2, (y1 + y2) / 2, b, Math.abs(x1 - x2) < 1]); };
    const cx = W / 2, cy = H / 2, sw = (W - 2 * pad);
    switch (ukl) {
      case 'prosty': { const a = sw; L(cx - a / 2, cy, cx + a / 2, cy, 'A'); zas = [cx - a / 2, cy]; break; }
      case 'srodek': { const k = sw / (d('A') + d('B')), a = d('A') * k, b = d('B') * k, x0 = (W - a - b) / 2; L(x0, cy, x0 + a, cy, 'A'); L(x0 + a, cy, x0 + a + b, cy, 'B'); zas = [x0 + a, cy]; break; }
      case 'L': case 'sciana': { const k = Math.min(sw / d('A'), (H - 2 * pad) / d('B')), a = d('A') * k, b = d('B') * k, x0 = (W - a) / 2, y0 = pad; L(x0, y0, x0 + a, y0, 'A'); L(x0 + a, y0, x0 + a, y0 + b, 'B'); zas = [x0, y0]; break; }
      case 'U': { const k = Math.min(sw / d('B'), (H - 2 * pad) / Math.max(d('A'), d('C'))), a = d('A') * k, b = d('B') * k, c = d('C') * k, x0 = (W - b) / 2, y0 = H - pad; L(x0, y0 - a, x0, y0, 'A'); L(x0, y0, x0 + b, y0, 'B'); L(x0 + b, y0, x0 + b, y0 - c, 'C'); zas = [x0, y0 - a]; break; }
      case 'T': { const k = Math.min(sw / (d('A') + d('B')), (H - 2 * pad) / d('C')), a = d('A') * k, b = d('B') * k, c = d('C') * k, x0 = (W - a - b) / 2, y0 = pad; L(x0, y0, x0 + a, y0, 'A'); L(x0 + a, y0, x0 + a + b, y0, 'B'); L(x0 + a, y0, x0 + a, y0 + c, 'C'); zas = [x0, y0]; break; }
      case 'X': { const k = Math.min(sw / (d('A') + d('C')), (H - 2 * pad) / (d('B') + d('D'))), a = d('A') * k, b = d('B') * k, c = d('C') * k, dd = d('D') * k, xm = (W - a - c) / 2 + a, y = (H - b - dd) / 2 + b; L(xm - a, y, xm, y, 'A'); L(xm, y - b, xm, y, 'B'); L(xm, y, xm + c, y, 'C'); L(xm, y, xm, y + dd, 'D'); zas = [xm - a, y]; break; }
      case 'prostokat': { const k = Math.min(sw / d('A'), (H - 2 * pad) / d('B')), a = d('A') * k, b = d('B') * k, x0 = (W - a) / 2, y0 = (H - b) / 2; L(x0, y0, x0 + a, y0, 'A'); L(x0 + a, y0, x0 + a, y0 + b, 'B'); L(x0 + a, y0 + b, x0, y0 + b, null); L(x0, y0 + b, x0, y0, null); zas = [x0 + a / 2, y0]; break; }
    }
    if (s.lustro && R && R.kierunek) { lines.forEach((l) => { l[0] = W - l[0]; l[2] = W - l[2]; }); labels.forEach((l) => { l[0] = W - l[0]; }); if (zas) zas[0] = W - zas[0]; }
    const kol = s.kolor === 'bialy' ? '#bdbab3' : s.kolor === 'zloty' ? '#b8913f' : '#1c1c1c';
    const dl = (b) => (num(s.dl[b]) ? `${b} = ${fm(num(s.dl[b]))} m` : b);
    return `<svg class="kl-ks__svg" viewBox="-30 0 ${W + 60} ${H}" role="img" aria-label="Rysunek układu ${esc(u.n)}">
      ${ukl === 'sciana' ? `<line x1="${lines[1][0] + 8}" y1="${pad - 10}" x2="${lines[1][0] + 8}" y2="${H - 6}" stroke="#c9c5bc" stroke-width="3" stroke-dasharray="4 4"/>` : ''}
      ${lines.map(([a, b, c, e]) => `<line x1="${a}" y1="${b}" x2="${c}" y2="${e}" stroke="${kol}" stroke-width="7" stroke-linecap="round"/>`).join('')}
      ${zas ? `<circle cx="${zas[0]}" cy="${zas[1]}" r="7" fill="#d9822b" stroke="#fff" stroke-width="2"/>` : ''}
      ${labels.map(([x, y, b, pion]) => `<text x="${pion ? x + 9 : x}" y="${pion ? y + 4 : y - 9}" text-anchor="${pion ? 'start' : 'middle'}" font-size="12" font-weight="700" fill="#1f4f86">${esc(dl(b))}</text>`).join('')}
    </svg><p class="kl-ks__leg"><span class="kl-ks__kropka"></span> zasilanie</p>`;
  }

  /* ---------- schematy montazu (SVG, kolor szyny) ---------- */
  function rysMontaz(k) {
    const kol = s.kolor === 'bialy' ? '#bdbab3' : '#1c1c1c', sufit = '#8a8780', gk = '#c9c5bc';
    const lampa = (x, y) => `<rect x="${x - 4}" y="${y}" width="8" height="10" fill="${kol}"/><path d="M${x - 9} ${y + 10}h18l-4 12h-10z" fill="${kol}"/><path d="M${x - 14} ${y + 26}l-8 18M${x + 14} ${y + 26}l8 18" stroke="#e6c35a" stroke-width="2" opacity=".7"/>`;
    let g = '';
    if (k === 'natynk') g = `<rect x="0" y="8" width="160" height="8" fill="${sufit}"/><rect x="20" y="16" width="120" height="8" rx="1" fill="${kol}"/>${lampa(55, 24)}${lampa(105, 24)}`;
    if (k === 'zwis') g = `<rect x="0" y="0" width="160" height="8" fill="${sufit}"/><path d="M40 8v24M120 8v24" stroke="#777" stroke-width="1.5"/><rect x="20" y="32" width="120" height="7" rx="1" fill="${kol}"/>${lampa(80, 39)}`;
    if (k === 'wpusz' || k === 'podwieszany') g = `<rect x="0" y="8" width="58" height="10" fill="${k === 'podwieszany' ? gk : sufit}"/><rect x="102" y="8" width="58" height="10" fill="${k === 'podwieszany' ? gk : sufit}"/><rect x="58" y="2" width="44" height="16" fill="${kol}"/>${k === 'podwieszany' ? '<path d="M0 0h160" stroke="#8a8780" stroke-width="3" stroke-dasharray="6 4"/>' : ''}${lampa(80, 18)}`;
    if (k === 'tradycyjny') g = `<rect x="0" y="4" width="160" height="16" fill="${sufit}"/><rect x="58" y="6" width="44" height="14" fill="${kol}"/>${lampa(80, 20)}`;
    return `<svg class="kl-ks__mrys" viewBox="0 0 160 70" aria-hidden="true">${g}</svg>`;
  }
  function kafelMontaz(k, n, opis, attr, on) {
    const z = SYS.zdjecia_montazu && SYS.zdjecia_montazu[k];
    const img = z ? `<span class="kl-ks__mfoto"><img src="${esc(z)}" alt="${esc(n)}" loading="lazy" width="480" height="320">${rysMontaz(k)}</span>` : `<span class="kl-ks__mfoto kl-ks__mfoto--rys">${rysMontaz(k)}</span>`;
    return kafel(on, attr, `${img}<span class="kl-ks__kt">${esc(n)}</span><span class="kl-ks__kp">${esc(opis)}</span>`);
  }
  function brakuje() {
    if (s.krok === 0) return 'Wybierz układ szyny.';
    if (s.krok === 1) { const b = []; if (!s.montaz) b.push('sposób montażu'); if (s.montaz === 'wpusz' && SYS.sufity && !s.sufit) b.push('rodzaj sufitu'); if (!s.kolor) b.push('kolor szyny'); return b.length ? 'Wybierz: ' + b.join(', ') + '.' : ''; }
    if (s.krok === 2) return 'Wpisz długość każdego boku.';
    if (s.krok === 3) return 'Zmniejsz moc opraw (przekroczony limit).';
    return '';
  }
  function navHtml(bok) {
    if (s.krok >= 4) return bok ? '' : `<div class="kl-ks__nav"><button type="button" class="kl-ks__wstecz" data-wstecz>Wstecz</button><span></span></div>`;
    const ok = krokOk(s.krok);
    const dal = `<button type="button" class="kl-ks__dalej" data-dalej ${ok ? '' : 'disabled'}>Dalej: ${esc(KROKI[s.krok + 1])} <span aria-hidden="true">→</span></button>`;
    if (bok) return `<div class="kl-ks__navbok">${dal}${ok ? '' : `<p class="kl-ks__info">${esc(brakuje())}</p>`}</div>`;
    return `<div class="kl-ks__nav">${s.krok > 0 ? '<button type="button" class="kl-ks__wstecz" data-wstecz>Wstecz</button>' : '<span></span>'}<div class="kl-ks__navp">${ok ? '' : `<span class="kl-ks__navinfo">${esc(brakuje())}</span>`}${dal}</div></div>`;
  }

  /* ---------- render ---------- */
  function krokOk(i) {
    if (i === 0) return !!s.uklad;
    if (i === 1) return !!s.montaz && !!s.kolor && (s.montaz !== 'wpusz' || !SYS.sufity || !!s.sufit);
    if (i === 2) return wymiaryOk();
    if (i === 3) { const m = maxW(); return !(m && mocOpraw() > m); }
    return true;
  }
  function maxKrok() { let i = 0; while (i < 4 && krokOk(i)) i++; return i; }

  function renderKroki() {
    const mk = maxKrok();
    $kroki.innerHTML = KROKI.map((k, i) => `<li class="${i === s.krok ? 'is-on' : ''} ${i < s.krok && krokOk(i) ? 'is-ok' : ''}"><button type="button" data-krok="${i}" ${i > mk ? 'disabled' : ''}><span class="kl-ks__nr">${i + 1}</span>${esc(k)}</button></li>`).join('');
  }
  function kafel(on, attrs, html, dis) { return `<button type="button" class="kl-ks__kafel ${on ? 'is-on' : ''}" ${attrs} ${dis ? 'disabled' : ''}>${html}</button>`; }

  function renderMain() {
    let h = '';
    if (s.krok === 0) {
      h += `<h2 class="kl-ks__h2">1. Wybierz układ szyny</h2><p class="kl-ks__pod">${esc(SYS.opis)}</p><div class="kl-ks__siatka">`;
      SYS.uklady.forEach((k) => { const u = UKLADY[k]; h += kafel(s.uklad === k, `data-uklad="${k}"`, `<span class="kl-ks__rys">${svg(k)}</span><span class="kl-ks__kt">${esc(u.n)}</span><span class="kl-ks__kp">${esc((SYS.opisy_ukladow && SYS.opisy_ukladow[k]) || u.opis)}</span>`); });
      h += `</div>`;
    } else if (s.krok === 1) {
      h += `<h2 class="kl-ks__h2">2. Sposób montażu i kolor szyny</h2><div class="kl-ks__siatka kl-ks__siatka--3">`;
      SYS.montaze.filter((k) => !(s.uklad === 'sciana' && k === 'zwis')).forEach((k) => { h += kafelMontaz(k, MONTAZE[k].n, (SYS.opisy_montazu && SYS.opisy_montazu[k]) || MONTAZE[k].opis, `data-montaz="${k}"`, s.montaz === k); });
      h += `</div>`;
      if (s.montaz === 'wpusz' && SYS.sufity) {
        h += `<h3 class="kl-ks__h3">Rodzaj sufitu</h3><div class="kl-ks__siatka kl-ks__siatka--3">` + [['tradycyjny', 'Sufit tradycyjny', 'Beton albo zabudowa, szyna w wyfrezowanym rowku.'], ['podwieszany', 'Sufit podwieszany', 'Płyta g-k, szyna na uchwytach montażowych.']].map(([k, n, o]) => { const z = SYS.zdjecia_montazu; return `<button type="button" class="kl-ks__kafel ${s.sufit === k ? 'is-on' : ''}" data-sufit="${k}"><span class="kl-ks__mfoto kl-ks__mfoto--rys">${rysMontaz(k)}</span><span class="kl-ks__kt">${n}</span><span class="kl-ks__kp">${o}</span></button>`; }).join('') + `</div>`;
      }
      h += `<h3 class="kl-ks__h3">Kolor szyny i łączników</h3><div class="kl-ks__filtry">` + SYS.kolory.map((k) => `<button type="button" class="kl-ks__chip ${s.kolor === k ? 'is-on' : ''}" data-kolor="${k}"><span class="kl-ks__probka" style="background:${KOLORY[k].c}"></span>${KOLORY[k].n}</button>`).join('') + `</div>`;
      if (UKLADY[s.uklad] && UKLADY[s.uklad].L && R.naroznik_flex) h += `<label class="kl-ks__check"><input type="checkbox" data-flex ${s.flex ? 'checked' : ''}> Narożniki pod innym kątem niż 90° albo przejście sufit-ściana (łącznik elastyczny zamiast kątowego)</label>`;
      if (R.oslona) h += `<label class="kl-ks__check"><input type="checkbox" data-oslona ${s.oslona ? 'checked' : ''}> ${esc(R.oslona_opis || 'Dodaj osłonę szczeliny szyny (dust cover) na całą długość')}</label>`;
      if (R.kierunek && UKLADY[s.uklad] && (UKLADY[s.uklad].L || UKLADY[s.uklad].T || UKLADY[s.uklad].zas === 'koniec')) h += `<label class="kl-ks__check"><input type="checkbox" data-lustro ${s.lustro ? 'checked' : ''}> Układ w lustrzanym odbiciu (zasilanie po prawej, narożniki w lewo). ${esc(R.kierunek)}</label>`;
    } else if (s.krok === 2) {
      const u = UKLADY[s.uklad];
      h += `<h2 class="kl-ks__h2">3. Wymiary</h2><p class="kl-ks__pod">Podaj długości w metrach (np. 3,4). ${esc(SYS.opis_szyn || '')} Maksymalnie ${SYS.max_m} m w jednym systemie${u.x2 ? '; prostokąt liczymy jako 2 x A + 2 x B' : ''}.</p><div class="kl-ks__wym"><div class="kl-ks__pola">`;
      u.boki.forEach((b) => { h += `<label class="kl-ks__pole"><span>Bok ${b}</span><input type="text" inputmode="decimal" data-dl="${b}" value="${esc(s.dl[b] || '')}" placeholder="np. 2,5" autocomplete="off"><em>m</em></label>`; });
      h += `</div><div class="kl-ks__podglad" data-podglad>${svg()}</div></div><div data-wynik>${wynikHtml()}</div>`;
    } else if (s.krok === 3) {
      const rodz = [...new Set(LAMPY.map((l) => l.rodz))];
      const lm = dlugoscCalk();
      h += `<h2 class="kl-ks__h2">4. Oprawy do szyny ${esc(SYS.nazwa)}</h2><p class="kl-ks__pod">Pokazujemy tylko oprawy pasujące do tej szyny. Przy ${fm(lm)} m szyny zwykle wystarcza ok. ${Math.max(1, Math.round(lm / (SYS.podpowiedz_oprawy_m || 0.8)))} opraw. Możesz też pominąć ten krok.</p>`;
      h += mocHtml();
      h += `<div class="kl-ks__filtry"><span class="kl-ks__etyk">Kolor:</span>` + [['wszystkie', 'Wszystkie'], ['czarny', 'Czarne'], ['bialy', 'Białe'], ['inne', 'Inne']].map(([k, n]) => `<button type="button" class="kl-ks__chip ${s.fk === k ? 'is-on' : ''}" data-fk="${k}">${n}</button>`).join('') + `</div>`;
      h += `<div class="kl-ks__filtry kl-ks__filtry--model"><span class="kl-ks__etyk">Model:</span><button type="button" class="kl-ks__chip ${s.fr === 'wszystkie' ? 'is-on' : ''}" data-fr="wszystkie">Wszystkie</button>` + rodz.map((r) => `<button type="button" class="kl-ks__chip ${s.fr === r ? 'is-on' : ''}" data-fr="${esc(r)}">${esc(r)}</button>`).join('') + `</div><div class="kl-ks__siatka kl-ks__siatka--opr">`;
      LAMPY.filter((l) => (s.fk === 'wszystkie' || l.kol === s.fk) && (s.fr === 'wszystkie' || l.rodz === s.fr)).forEach((l) => {
        const n = s.opr[l.v] || 0;
        h += `<div class="kl-ks__opr ${n ? 'is-on' : ''} ${l.a ? '' : 'is-brak'}"><a class="kl-ks__img" href="/products/${esc(l.h)}" target="_blank" rel="noopener">${l.i ? `<img src="${esc(l.i)}" alt="" loading="lazy" width="360" height="360">` : '<span class="kl-ks__brakimg"></span>'}</a>
          <span class="kl-ks__kt">${esc(l.tk)}</span><span class="kl-ks__kp">${l.w ? fm(l.w) + ' W · ' : ''}${l.a ? 'dostępna' : 'chwilowo niedostępna'}</span>
          <span class="kl-ks__kc">${zl(l.c)}${l.cc > l.c ? ` <s>${zl(l.cc)}</s>` : ''}</span>
          <span class="kl-ks__stepper"><button type="button" data-minus="${l.v}" aria-label="mniej" ${n ? '' : 'disabled'}>−</button><output>${n}</output><button type="button" data-plus="${l.v}" aria-label="więcej" ${l.a ? '' : 'disabled'}>+</button></span></div>`;
      });
      h += `</div>`;
    } else {
      h += `<h2 class="kl-ks__h2">5. Podsumowanie</h2><div class="kl-ks__wym"><div>${opisKonfig()}</div><div class="kl-ks__podglad">${svg()}</div></div>`;
      const o = oblicz();
      h += `<h3 class="kl-ks__h3">Szyna, zasilanie i akcesoria</h3>${listaHtml(o.poz.map((x) => ({ t: x.nazwa, sku: x.sku, p: x.p, n: x.n })))}`;
      h += uwagiHtml(o);
      const lw = lampyWybrane();
      h += `<h3 class="kl-ks__h3">Oprawy</h3>` + (lw.length ? listaHtml(lw.map((x) => ({ t: x.l.tk, sku: x.l.s, p: x.l, n: x.n }))) : `<p class="kl-ks__pod">Nie wybrano opraw. <button type="button" class="kl-ks__link" data-krok="3">Dobierz oprawy</button></p>`);
      (SYS.dodatki || []).forEach((d) => { h += `<p class="kl-ks__info">${esc(d.tekst)}: <a href="${esc(d.url)}">przejdź</a>.</p>`; });
      h += mailHtml();
    }
    h += navHtml(false);
    $main.innerHTML = h;
  }

  function mocHtml() {
    const w = mocOpraw(), m = maxW(), z = dobierzZasilacze();
    let t = '';
    if (z) t += `<p class="kl-ks__info">Zasilacz dobieramy po mocy opraw: ${w ? esc(z.opis) : 'wybierz oprawy, a dobierzemy zasilacz'}.${z.n > 1 ? ' Każdy zasilacz to osobny punkt zasilania.' : ''}</p>`;
    if (m && w > m) t += `<p class="kl-ks__uwaga">Moc opraw ${fm(w)} W przekracza ${m} W dla tego montażu (${esc(SYS.max_w_zrodlo || '')}). Zmniejsz liczbę opraw albo podziel instalację.</p>`;
    return t;
  }
  function uwagiHtml(o) {
    let t = '';
    if (o.ciecie.length) t += `<p class="kl-ks__info">Docięcie: ${o.ciecie.map(esc).join('; ')}.</p>`;
    o.uwagi.forEach((x) => { t += `<p class="kl-ks__info">${esc(x)}</p>`; });
    (SYS.uwagi || []).forEach((x) => { t += `<p class="kl-ks__info">${esc(x)}</p>`; });
    return t + mocHtml();
  }

  function opisKonfig() {
    return `<ul class="kl-ks__opis"><li><b>System:</b> ${esc(SYS.nazwa)}</li><li><b>Układ:</b> ${esc(UKLADY[s.uklad].n)}${s.lustro ? ' (lustrzany)' : ''}</li><li><b>Montaż:</b> ${esc(MONTAZE[s.montaz].n)}${s.montaz === 'wpusz' && s.sufit ? ', sufit ' + esc(s.sufit) : ''}</li><li><b>Kolor:</b> ${esc(KOLORY[s.kolor].n)}</li><li><b>Długość:</b> ${fm(dlugoscCalk())} m (${UKLADY[s.uklad].boki.map((b) => `${b} ${fm(num(s.dl[b]))} m`).join(', ')})</li></ul>`;
  }

  function wynikHtml() {
    if (!wymiaryOk()) {
      const za = s.uklad && dlugoscCalk() > SYS.max_m;
      return `<p class="kl-ks__uwaga">${za ? `Łączna długość przekracza ${SYS.max_m} m. Podziel instalację na dwa systemy (dwa zasilania).` : `Wpisz długość każdego boku (od ${fm(SYS.min_bok || 0.3)} m).`}</p>`;
    }
    const o = oblicz();
    return `<h3 class="kl-ks__h3">Policzyliśmy (${fm(o.metry)} m szyny, ${o.odcinki} odc.)</h3>${listaHtml(o.poz.map((x) => ({ t: x.nazwa, sku: x.sku, p: x.p, n: x.n })))}${uwagiHtml(o)}`;
  }

  function listaHtml(rows) {
    return `<ul class="kl-ks__lista">` + rows.map((r) => {
      if (!r.p) return `<li><span class="kl-ks__limg"><span class="kl-ks__brakimg"></span></span><span class="kl-ks__lt">${esc(r.t)}<small>SKU ${esc(r.sku || '?')}: brak w sklepie, zapytaj nas</small></span><span class="kl-ks__lc">${r.n} szt.</span></li>`;
      return `<li><span class="kl-ks__limg">${r.p.i ? `<img src="${esc(r.p.i)}" alt="" loading="lazy" width="64" height="64">` : '<span class="kl-ks__brakimg"></span>'}</span><span class="kl-ks__lt"><a href="/products/${esc(r.p.h)}" target="_blank" rel="noopener">${esc(r.t)}</a><small>SKU ${esc(r.sku || r.p.s)}${r.p.a ? '' : ' · <b class="kl-ks__czer">na zamówienie</b>'}</small></span><span class="kl-ks__lc">${r.n} x ${zl(r.p.c)}<br><strong>${zl(r.n * r.p.c)}</strong></span></li>`;
    }).join('') + `</ul>`;
  }

  /* ---------- wyslij zestaw na e-mail (lead, endpoint VPS kl_reklamacje_api.py /reklamacje/zestaw) ---------- */
  const API_ZESTAW = 'https://kl-api.pro-position.pl/reklamacje/zestaw';
  const TEST_KLUCZ = new URLSearchParams(location.search).get('kltest'); /* test end-to-end (klucz z konfiguracji VPS) */
  function linkZestawu() { const q = stanQ(); q.set('kr', '4'); q.set('zestaw', '1'); return `${location.origin}${location.pathname}?${q}`; }
  let LEADY = !!TEST_KLUCZ;  /* formularz tylko gdy endpoint wlaczony (leady_live na VPS) albo test */
  fetch(API_ZESTAW + '/stan').then((r) => r.json()).then((j) => { if (j && j.live && !LEADY) { LEADY = true; if (s.krok === 4) render(false); } }).catch(() => {});
  function mailHtml() {
    if (!LEADY) return '';
    if (s.mailOk) return `<section class="kl-ks__mail"><h3 class="kl-ks__h3">Zestaw wysłany</h3><p class="kl-ks__pod">${esc(s.mailOk)}</p></section>`;
    return `<section class="kl-ks__mail" id="kl-ks-mail"><h3 class="kl-ks__h3">Wyślij zestaw na e-mail</h3>
      <p class="kl-ks__pod">Dostaniesz listę elementów z cenami i link, który otworzy ten zestaw (np. żeby pokazać go elektrykowi albo wrócić do zakupu).</p>
      <form data-mailform novalidate>
        <div class="kl-ks__mailrow"><label class="kl-ks__sr" for="kl-ks-email">Adres e-mail</label>
          <input id="kl-ks-email" type="email" name="email" required autocomplete="email" placeholder="Twój adres e-mail">
          <button type="submit" class="kl-ks__dalej" ${s.mailBusy ? 'disabled' : ''}>${s.mailBusy ? 'Wysyłamy...' : 'Wyślij zestaw'}</button></div>
        <input type="text" name="website" tabindex="-1" autocomplete="off" class="kl-ks__hp" aria-hidden="true">
        <label class="kl-ks__check"><input type="checkbox" name="zgoda" value="1"> Chcę otrzymywać newsletter Kraina Lamp: nowości, promocje i porady o oświetleniu. Wypisać się mogę w każdej chwili.</label>
        <p class="kl-ks__info">Adres e-mail wykorzystamy, żeby wysłać ten zestaw i odpowiedzieć na pytania o niego. Szczegóły przetwarzania danych w <a href="/policies/privacy-policy">polityce prywatności</a>.</p>
        <p class="kl-ks__msg kl-ks__msg--blad" data-mailmsg hidden></p>
      </form></section>`;
  }
  async function wyslijMail(f) {
    const msg = f.querySelector('[data-mailmsg]');
    const email = (f.email.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(email)) { msg.hidden = false; msg.textContent = 'Podaj poprawny adres e-mail.'; return; }
    const poz = wszystkiePozycje();
    if (!poz.length) { msg.hidden = false; msg.textContent = 'Zestaw jest pusty.'; return; }
    const fd = new FormData();
    fd.append('email', email); fd.append('zgoda', f.zgoda.checked ? '1' : '0'); fd.append('website', f.website.value || '');
    fd.append('konfigurator', SYS.id); fd.append('system', SYS.nazwa); fd.append('link', linkZestawu());
    fd.append('pozycje', JSON.stringify(poz.map((x) => ({ t: x.t, sku: x.p.s || '', q: x.q, c: x.p.c }))));
    if (TEST_KLUCZ) fd.append('test', TEST_KLUCZ);
    s.mailBusy = true; f.querySelector('button[type=submit]').disabled = true; f.querySelector('button[type=submit]').textContent = 'Wysyłamy...';
    try {
      const r = await fetch(API_ZESTAW, { method: 'POST', body: fd });
      const j = await r.json().catch(() => ({}));
      s.mailBusy = false;
      if (r.ok && j.ok) { s.mailOk = `Wysłaliśmy zestaw na ${email}. Sprawdź skrzynkę (także folder Oferty albo Spam).`; renderMain(); return; }
      msg.hidden = false; msg.textContent = j.blad || 'Nie udało się wysłać. Spróbuj ponownie za chwilę.';
    } catch (_) { s.mailBusy = false; msg.hidden = false; msg.textContent = 'Brak połączenia. Spróbuj ponownie za chwilę.'; }
    const btn = f.querySelector('button[type=submit]'); btn.disabled = false; btn.textContent = 'Wyślij zestaw';
  }

  function rabat() { return SYS.rabat_zestaw && SYS.rabat_zestaw.pokaz ? SYS.rabat_zestaw : null; }

  function renderBok() {
    const poz = wszystkiePozycje();
    const suma = poz.reduce((a, x) => a + x.q * x.p.c, 0);
    const nl = lampyWybrane().reduce((a, x) => a + x.n, 0);
    const szt = poz.reduce((a, x) => a + x.q, 0) - nl;
    const moc = mocOpraw(), m = maxW();
    let h = `<h2 class="kl-ks__h2">Twój zestaw</h2>`;
    if (s.uklad) h += `<div class="kl-ks__mini">${svg()}</div>`;
    h += `<dl class="kl-ks__dl"><dt>Szyna i akcesoria</dt><dd>${szt} szt.</dd><dt>Oprawy</dt><dd>${nl} szt.${moc ? `, ${fm(moc)} W` : ''}</dd>${m && moc > m ? `<dd class="kl-ks__czer">Przekroczona moc ${m} W</dd>` : ''}</dl>`;
    const rb = rabat();
    if (rb) {
      const ok = poz.some((x) => x.r === 'szyna') && poz.filter((x) => x.r === 'oprawa').reduce((a, x) => a + x.q, 0) >= (rb.min_opraw || 2);
      h += ok ? `<p class="kl-ks__rabat">Rabat za zestaw: -${rb.procent}% na elementy i oprawy tego zestawu, naliczy się w koszyku (ok. ${zl(Math.round(suma * rb.procent / 100))}).${rb.podglad ? ' <b>PODGLĄD: propozycja, rabat nieaktywny.</b>' : ''}</p>`
              : `<p class="kl-ks__info">Rabat za zestaw -${rb.procent}%: dodaj szynę i co najmniej ${rb.min_opraw || 2} oprawy.</p>`;
    }
    h += `<p class="kl-ks__suma">Razem <strong>${zl(suma)}</strong></p>`;
    h += `<button type="button" class="kl-ks__dodaj" data-dodaj ${poz.length && !s.busy && s.krok === 4 ? '' : 'disabled'}>${s.busy ? 'Dodajemy...' : 'Dodaj zestaw do koszyka'}</button>`;
    if (s.krok < 4) h += navHtml(true) + `<p class="kl-ks__info">„Dodaj zestaw” będzie aktywny w podsumowaniu.</p>`;
    if (s.krok === 4) h += `<button type="button" class="kl-ks__link" data-kopiuj>Kopiuj link do tego zestawu</button> · <button type="button" class="kl-ks__link" data-drukuj>Pobierz PDF / drukuj</button>${LEADY ? ' · <a class="kl-ks__link" href="#kl-ks-mail">Wyślij na e-mail</a>' : ''}`;
    if (s.msg) h += `<p class="kl-ks__msg kl-ks__msg--${s.msg.typ}">${s.msg.t}</p>`;
    $bok.innerHTML = h;
  }

  function render(scroll) { renderKroki(); renderMain(); renderBok(); zapiszUrl(); if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  /* ---------- URL (zapis konfiguracji) ---------- */
  function stanQ() {
    const q = new URLSearchParams();
    if (s.uklad) q.set('u', s.uklad); if (s.montaz) q.set('m', s.montaz); if (s.sufit) q.set('sf', s.sufit); if (s.kolor) q.set('k', s.kolor);
    if (s.flex) q.set('fx', '1'); if (s.lustro) q.set('lu', '1'); if (s.oslona) q.set('os', '1');
    Object.entries(s.dl).forEach(([b, v]) => { if (v) q.set(b.toLowerCase(), String(v).replace(',', '.')); });
    const o = Object.entries(s.opr).filter(([, n]) => n > 0).map(([v, n]) => `${v}x${n}`).join(','); if (o) q.set('o', o);
    return q;
  }
  function zapiszUrl() { const q = stanQ(); if (s.krok) q.set('kr', s.krok); history.replaceState(null, '', `${location.pathname}${q.toString() ? '?' + q : ''}`); }
  function wczytajUrl() {
    const q = new URLSearchParams(location.search);
    if (UKLADY[q.get('u')] && SYS.uklady.includes(q.get('u'))) s.uklad = q.get('u');
    if (MONTAZE[q.get('m')] && SYS.montaze.includes(q.get('m'))) s.montaz = q.get('m');
    if (['tradycyjny', 'podwieszany'].includes(q.get('sf'))) s.sufit = q.get('sf');
    if (SYS.kolory.includes(q.get('k'))) s.kolor = q.get('k');
    s.flex = q.get('fx') === '1'; s.lustro = q.get('lu') === '1'; s.oslona = q.get('os') === '1';
    ['A', 'B', 'C', 'D'].forEach((b) => { const v = q.get(b.toLowerCase()); if (v) s.dl[b] = v.replace('.', ','); });
    (q.get('o') || '').split(',').forEach((x) => { const [v, n] = x.split('x'); if (v && +n > 0 && LAMPY.find((l) => String(l.v) === v)) s.opr[v] = Math.min(+n, 99); });
    const kr = +q.get('kr') || 0; s.krok = Math.min(kr, maxKrok());
  }
  function idZestawu() { let h = 0; const t = SYS.id + '|' + stanQ().toString(); for (let i = 0; i < t.length; i++) h = (h * 31 + t.charCodeAt(i)) >>> 0; return SYS.id + '-' + h.toString(36); }

  /* ---------- koszyk ---------- */
  async function dodaj() {
    const wsz = wszystkiePozycje();
    const poz = wsz.filter((x) => x.p.a), pomin = wsz.filter((x) => !x.p.a);
    if (!poz.length || s.busy) return;
    s.busy = true; s.msg = null; renderBok();
    const zid = idZestawu();
    const sekcje = [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);
    const post = async (items, withSec) => {
      const body = { items: items.map((x) => ({ id: x.v, quantity: x.q, properties: { _zestaw: zid, _konfigurator: SYS.id, _rola: x.r } })) };
      if (withSec && sekcje.length) { body.sections = sekcje.join(','); body.sections_url = location.pathname; }
      for (let p = 0; ; p++) {
        const r = await fetch(ROOT_URL + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        if (r.status === 429 && p < 3) { await new Promise((res) => setTimeout(res, 1500 * (p + 1))); continue; }
        const j = await r.json(); return { ok: r.ok && !j.status, j };
      }
    };
    let ok = 0, sections = {}; const bledy = [];
    try {
      const r = await post(poz, true);
      if (r.ok) { ok = poz.reduce((a, x) => a + x.q, 0); sections = r.j.sections || {}; }
      else {
        for (let i = 0; i < poz.length; i++) {
          try { const r2 = await post([poz[i]], i === poz.length - 1); if (r2.ok) { ok += poz[i].q; if (r2.j.sections) sections = r2.j.sections; } else bledy.push(`${poz[i].t}: ${r2.j.description || 'brak wystarczającej ilości'}`); }
          catch (_) { bledy.push(`${poz[i].t}: błąd połączenia`); }
        }
      }
    } catch (_) { bledy.push('błąd połączenia'); }
    pomin.forEach((x) => bledy.push(`${x.t}: niedostępne`));
    let ile = 0; try { ile = (await (await fetch(ROOT_URL + 'cart.js', { headers: { Accept: 'application/json' } })).json()).item_count; } catch (_) {}
    if (ok) document.dispatchEvent(new CartAddEvent({}, 'kl-konfig-szyn', { source: 'kl-konfig-szyn', itemCount: ile, sections }));
    s.busy = false;
    s.msg = bledy.length ? { typ: 'blad', t: `${ok ? `Dodano ${ok} szt. ` : ''}Nie dodaliśmy: ${bledy.map(esc).join('; ')}.` } : { typ: 'ok', t: `Dodano do koszyka: ${ok} szt. <a href="${ROOT_URL}cart">Przejdź do koszyka</a>` };
    renderBok();
  }

  /* ---------- zdarzenia ---------- */
  root.addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b || b.disabled) return;
    const d = b.dataset;
    if (d.krok != null) { s.krok = +d.krok; s.msg = null; render(true); return; }
    if (d.uklad) { s.uklad = d.uklad; if (s.uklad === 'sciana' && s.montaz === 'zwis') s.montaz = null; Object.keys(s.dl).forEach((k) => { if (!UKLADY[s.uklad].boki.includes(k)) delete s.dl[k]; }); render(false); return; }
    if (d.montaz) { s.montaz = d.montaz; if (s.montaz !== 'wpusz') s.sufit = null; render(false); return; }
    if (d.sufit) { s.sufit = d.sufit; render(false); return; }
    if (d.kolor) { s.kolor = d.kolor; render(false); return; }
    if (d.fk) { s.fk = d.fk; renderMain(); return; }
    if (d.fr) { s.fr = d.fr; renderMain(); return; }
    if (d.plus) { s.opr[d.plus] = Math.min((s.opr[d.plus] || 0) + 1, 99); renderMain(); renderBok(); renderKroki(); zapiszUrl(); return; }
    if (d.minus) { s.opr[d.minus] = Math.max((s.opr[d.minus] || 0) - 1, 0); renderMain(); renderBok(); renderKroki(); zapiszUrl(); return; }
    if (b.hasAttribute('data-dalej')) { if (krokOk(s.krok)) { s.krok++; render(true); } return; }
    if (b.hasAttribute('data-wstecz')) { s.krok = Math.max(0, s.krok - 1); render(true); return; }
    if (b.hasAttribute('data-dodaj')) { dodaj(); return; }
    if (b.hasAttribute('data-kopiuj')) { navigator.clipboard && navigator.clipboard.writeText(location.href).then(() => { s.msg = { typ: 'ok', t: 'Link skopiowany. Otwórz go później albo wyślij elektrykowi.' }; renderBok(); }); return; }
    if (b.hasAttribute('data-drukuj')) { window.print(); return; }
  });
  root.addEventListener('submit', (e) => { const f = e.target.closest('[data-mailform]'); if (!f) return; e.preventDefault(); if (!s.mailBusy) wyslijMail(f); });
  root.addEventListener('change', (e) => {
    if (e.target.matches('[data-flex]')) { s.flex = e.target.checked; render(false); }
    if (e.target.matches('[data-lustro]')) { s.lustro = e.target.checked; render(false); }
    if (e.target.matches('[data-oslona]')) { s.oslona = e.target.checked; render(false); }
  });
  root.addEventListener('input', (e) => {
    const t = e.target; if (!t.matches('[data-dl]')) return;
    s.dl[t.dataset.dl] = t.value.replace(/[^\d.,]/g, '');
    const pg = root.querySelector('[data-podglad]'); if (pg) pg.innerHTML = svg();
    const w = root.querySelector('[data-wynik]'); if (w) w.innerHTML = wynikHtml();
    root.querySelectorAll('[data-dalej]').forEach((d) => { d.disabled = !krokOk(s.krok); });
    const ni = root.querySelector('.kl-ks__navinfo'); if (ni) ni.textContent = krokOk(s.krok) ? '' : brakuje();
    renderKroki(); renderBok(); zapiszUrl();
  });

  /* podglad motywu: belka Shopify na dole zaslania sticky "Dalej" -> odsun belke nawigacji */
  [500, 2000, 5000].forEach((t) => setTimeout(() => { const pb = document.getElementById('PBarNextFrame'); if (pb) { const r = pb.getBoundingClientRect(); const h = r.height > 0 && r.height < 120 ? r.height : 64; root.style.setProperty('--kl-ks-dol', h + 'px'); } }, t));
  /* ---------- start ---------- */
  fetch(root.dataset.systemUrl).then((r) => r.json()).then(async (sys) => {
    SYS = sys; R = sys.reguly || {};
    const kol = [].concat(SYS.kolekcja || [], SYS.kolekcje || []);
    const skuL = [...new Set([...wszystkieSkuElementow(), ...(SYS.oprawy_sku || []).map(String)])];
    /* cache 10 min w sessionStorage (mniej zapytan do wyszukiwarki przy powrocie na strone) */
    const ck = 'kl-ks-v2-' + SYS.id + '-' + skuL.length;
    let cache = null;
    try { const c = JSON.parse(sessionStorage.getItem(ck) || 'null'); if (c && Date.now() - c.t < 600000) cache = c.p; } catch (_) {}
    if (cache) P = cache;
    else {
      const czesci = await Promise.all(kol.map(pobierzKolekcje).concat(SYS.dane === 'sku' ? [pobierzSku(skuL)] : [], SYS.produkty_uzupelnij ? [pobierzHandle(SYS.produkty_uzupelnij)] : []));
      P = [].concat(...czesci);
      try { sessionStorage.setItem(ck, JSON.stringify({ t: Date.now(), p: P })); } catch (_) {}
    }
    przygotuj(); wczytajUrl(); render(false);
  }).catch((err) => { console.error(err); $main.innerHTML = '<p class="kl-ks__uwaga">Nie udało się wczytać konfiguratora. Odśwież stronę albo napisz do nas.</p>'; });
}
